export default "__VITE_ASSET__Du56b50s__"